import { render, staticRenderFns } from "./RemBox.vue?vue&type=template&id=cdb13524&scoped=true&"
import script from "./RemBox.vue?vue&type=script&lang=js&"
export * from "./RemBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb13524",
  null
  
)

export default component.exports